export const demoCampaign = {
  id: 1,
  name: 'Hành Trình Xuyên Việt',
  description:
    'Tuyến tiếp sức nội bộ từ Lũng Cú đến Cà Mau. Mỗi thành viên chọn một cự ly, đóng góp km thật và cùng nhau lấp đầy bản đồ hành trình.',
  registerStart: '2026-05-01',
  registerEnd: '2026-12-31',
  startDate: '2026-05-11',
  endDate: '2026-12-31',
  sportTypes: ['Run', 'Walk'],
  raceDistances: [5, 10, 21, 42],
  minPace: null,
  maxPace: null,
  bannerUrl: '',
};

export const demoLeaderboard = [
  {
    user_id: 'demo-an',
    fullname: 'An Nguyễn',
    avatar: '',
    distance_register: 10,
    total_distance: 10000,
    total_moving_time: 3600,
    registered_at: '2026-05-11T01:00:00.000Z',
    strava_id: 'DEMO-001',
  },
  {
    user_id: 'demo-binh',
    fullname: 'Bình Trần',
    avatar: '',
    distance_register: 21,
    total_distance: 13600,
    total_moving_time: 5400,
    registered_at: '2026-05-11T02:00:00.000Z',
    strava_id: 'DEMO-002',
  },
  {
    user_id: 'demo-you',
    fullname: 'Bạn',
    avatar: '',
    distance_register: 10,
    total_distance: 4200,
    total_moving_time: 1680,
    registered_at: '2026-05-11T03:00:00.000Z',
    strava_id: 'DEMO-YOU',
  },
  {
    user_id: 'demo-chi',
    fullname: 'Chi Lê',
    avatar: '',
    distance_register: 42,
    total_distance: 0,
    total_moving_time: 0,
    registered_at: '2026-05-11T04:00:00.000Z',
    strava_id: 'DEMO-004',
  },
];

export const demoActivities = {
  summary: { distance: 27800 },
  data: [
    {
      id: 'demo-act-1',
      name: 'Morning run',
      type: 'Run',
      startDate: '2026-05-11T06:10:00.000Z',
      distance: 6200,
      pace: '6:05',
    },
    {
      id: 'demo-act-2',
      name: 'Đi bộ buổi tối',
      type: 'Walk',
      startDate: '2026-05-10T19:30:00.000Z',
      distance: 4200,
      pace: '10:20',
    },
  ],
};

export const demoCheckpoints = [
  {
    id: 'lung-cu',
    name: 'Lũng Cú',
    location: 'Hà Giang',
    distanceKm: 0,
    x: 176,
    y: 42,
    lat: 23.3628,
    lng: 105.3131,
    description: 'Cột cờ Lũng Cú, điểm cực Bắc mở đầu hành trình.',
    imageUrl: '',
    medalName: 'Khởi Hành',
  },
  {
    id: 'ha-noi',
    name: 'TP. Hà Nội',
    location: 'Hà Nội',
    distanceKm: 50,
    x: 186,
    y: 142,
    lat: 21.028511,
    lng: 105.804817,
    description: 'Thủ đô Việt Nam.',
    imageUrl: '',
    medalName: 'Hà Nội Phố',
  },
  {
    id: 'phong-nha',
    name: 'Phong Nha',
    location: 'Quảng Bình',
    distanceKm: 70,
    x: 196,
    y: 152,
    lat: 17.5905,
    lng: 106.2837,
    description: 'Vùng di sản hang động, checkpoint đầu tiên sau miền Bắc.',
    imageUrl: '',
    medalName: 'Di Sản Đá Vôi',
  },
  {
    id: 'hoi-an',
    name: 'Hội An',
    location: 'Quảng Nam',
    distanceKm: 100,
    x: 214,
    y: 216,
    lat: 15.8801,
    lng: 108.338,
    description: 'Phố cổ Hội An, điểm nhấn văn hoá miền Trung.',
    imageUrl: '',
    medalName: 'Phố Hội',
  },
  {
    id: 'da-lat',
    name: 'Đà Lạt',
    location: 'Lâm Đồng',
    distanceKm: 150,
    x: 192,
    y: 288,
    lat: 11.9404,
    lng: 108.4583,
    description: 'Cao nguyên thông xanh trước khi xuống cực Nam.',
    imageUrl: '',
    medalName: 'Cao Nguyên',
  },
  {
    id: 'ho-chi-minh',
    name: 'TP. Hồ Chí Minh',
    location: 'TP. Hồ Chí Minh',
    distanceKm: 250,
    x: 172,
    y: 328,
    lat: 10.823,
    lng: 106.63,
    description: 'Thành phố mang tên bác Hồ.',
    imageUrl: '',
    medalName: 'Sài Gòn',
  },
  {
    id: 'ca-mau',
    name: 'Cà Mau',
    location: 'Cà Mau',
    distanceKm: 300,
    x: 166,
    y: 350,
    lat: 8.6822,
    lng: 104.7967,
    description: 'Mũi Cà Mau, điểm kết thúc hành trình tiếp sức.',
    imageUrl: '',
    medalName: 'Về Đích',
  },
];

export const demoMedals = [
  { id: 'lung-cu', name: 'Khởi Hành', earned: true },
  { id: 'ha-noi', name: 'Hà Nội Phố', earned: true },
  { id: 'phong-nha', name: 'Di Sản Đá Vôi', earned: true },
  { id: 'hoi-an', name: 'Phố Hội', earned: true },
  { id: 'da-lat', name: 'Cao Nguyên', earned: true },
  { id: 'ho-chi-minh', name: 'Hòn Ngọc Viễn Đông', earned: false },
  { id: 'ca-mau', name: 'Về Đích', earned: false },
];
